import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
  fechados: [],
  selecionada: null,
  lastOrder: null,
  cpfClienteExpedicao: '',
  idClienteExpedicao: '',
  showQrPreviewExpedicao: false
});

function cpf(order) {
    return !order ? '' : order.cpf;
}

class LojaExpedicaoStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.LIST_CLOSED_ORDERS_FINISH:
                let result = state.set('fechados', action.itens);
                if (state.selecionada) {
                    const selecionada = result.fechados.find(o => o.id == state.selecionada.id);
                    result = result
                      .set('selecionada', selecionada)
                      .set('cpfClienteExpedicao', cpf(selecionada));
                }
                return result;

            case ActionTypes.SELECT_CLOSED_ORDER:
                const selecionada = state.fechados.find(o => o.id == action.orderId);
                return state
                    .set('selecionada', selecionada)
                    .set('cpfClienteExpedicao', selecionada.cpf)
                    .set('showQrPreviewExpedicao', false)
                    .set('idClienteExpedicao', '');

            case ActionTypes.UPDATE_TEXT:
                if (action.field === 'cpfClienteExpedicao')
                    return state.set('cpfClienteExpedicao', action.value);
                if (action.field === 'idClienteExpedicao')
                    return state.set('idClienteExpedicao', action.value);
                if (action.field === 'showQrPreviewExpedicao')
                    return state.set('showQrPreviewExpedicao', action.value);
                return state;

            case ActionTypes.DELIVER_ORDER_FINISH:
                return state
                    .set('lastOrder', state.fechados.find(o => o.id === action.orderId));

            default:
                return state;
        }
    }
}

export default new LojaExpedicaoStore();



// WEBPACK FOOTER //
// src/stores/LojaExpedicaoStore.js